var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 24.002C18.6274 24.002 24 18.6294 24 12.002C24 5.37454 18.6274 0.00195312 12 0.00195312C5.37258 0.00195312 0 5.37454 0 12.002C0 18.6294 5.37258 24.002 12 24.002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2681 12.002L16.0281 9.24198C16.3761 8.89398 16.3761 8.31798 16.0281 7.96998C15.6801 7.62198 15.1041 7.62198 14.7561 7.96998L11.9961 10.73L9.23612 7.96998C8.88812 7.62198 8.31213 7.62198 7.96413 7.96998C7.61613 8.31798 7.61613 8.89398 7.96413 9.24198L10.7241 12.002L7.96413 14.762C7.61613 15.11 7.61613 15.686 7.96413 16.034C8.14413 16.214 8.37212 16.298 8.60012 16.298C8.82812 16.298 9.05612 16.214 9.23612 16.034L11.9961 13.274L14.7561 16.034C14.9361 16.214 15.1641 16.298 15.3921 16.298C15.6201 16.298 15.8481 16.214 16.0281 16.034C16.3761 15.686 16.3761 15.11 16.0281 14.762L13.2681 12.002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.457fd632bdebd337fd1515791cd6410c.svg";
export { ForwardRef as ReactComponent };